import { all } from "redux-saga/effects";
import { saga as getInformativesGeojson } from "./actions/getInformativesGeojson";

export default all([getInformativesGeojson]);
